import React from "react";

interface FaithProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  stroke?: string;
  width?: number | string;
  height?: number | string;
}

const Faith: React.FC<FaithProps> = ({
  fill = "#3C3C3C",
  stroke = "none",
  width = 24,
  height = 24,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.0732422 21V13L4.07324 11.225V8L9.07324 5.5V4H7.07324V2H9.07324V0H11.0732V2H13.0732V4H11.0732V5.5L16.0732 8V11.225L20.0732 13V21H11.0732V16H9.07324V21H0.0732422ZM2.07324 19H7.07324V13.9H13.0732V19H18.0732V14.2L14.0732 12.4V9.05L10.0732 7L6.07324 9.05V12.4L2.07324 14.2V19ZM10.0732 12.5C10.4899 12.5 10.8441 12.3542 11.1357 12.0625C11.4274 11.7708 11.5732 11.4167 11.5732 11C11.5732 10.5833 11.4274 10.2292 11.1357 9.9375C10.8441 9.64583 10.4899 9.5 10.0732 9.5C9.65658 9.5 9.30241 9.64583 9.01074 9.9375C8.71908 10.2292 8.57324 10.5833 8.57324 11C8.57324 11.4167 8.71908 11.7708 9.01074 12.0625C9.30241 12.3542 9.65658 12.5 10.0732 12.5Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  );
};

export default Faith;
